/**
 * 表单验证
 * 调用方式:
 *      <form name:"myForm" formvalidate   rules="validateRules" >   [ name 为必填  ] 不设置 rules 自定义验证规则
 *      validateRules 写法
 $scope.validateRules = {
                "gracePeriod": [                 // input name
                    {  erromsg: "宽限期必须小于贷款期限",
                        condition: function (value) { // 规则
                            return value < parseFloat($scope.product.loanTerm) ? true : false;
                        }
                    }
                ]
            }
 *      需要验证的 input name 为必填 可通过HTML 设置默认验证
 *      controlle 中获取 formvalidateApi    formvalidateApi.run 运行检测   formvalidateApi.clear 清除
 *
 * 提供方法
 */

formvalidate.$inject = ['validator', 'formvalidateApi'] // ,
export default function formvalidate(validator, formvalidateApi) {
    return {
        restrict: 'EA',
        link(scope, element, attrs) {
            scope.ele = element
            const $form = scope[attrs.name]
            //  校验规则
            const validateRules = scope[attrs.rules]
            const formPO = (function () {
                const cache = {}
                return {
                    build(form, dom) {
                        cache.form = cache.form || form
                        //                      cache.dom =  cache.dom || dom;
                        const $input = $(dom)

                        const $inputGrop = $input.parent() // $input.parent(".form-group").length === 0 ? $input.parents(".form-group").eq(0) : $input.parent(".form-group");
                        const $erromsg = $('<span class=\'erro_msg\' />')
                        const $erromsgwrap = $('<div class=\'erro_msg_wrap\' />')
                        $inputGrop.append($erromsgwrap)
                        $erromsgwrap.append($erromsg)
                        const _clear = function () {
                            $inputGrop.removeClass('has-error')
                            $erromsg.text('')
                        }
                        $input.on('focus', () => {
                            _clear()
                        }).on('click', () => {
                            _clear()
                        })
                        return {
                            rejected(msg) {
                                $inputGrop.addClass('has-error')
                                $erromsg.text(msg)
                            },
                        }
                    },
                    clear(ele) {
                        if (ele) {
                            $(ele).parent('.input-group').removeClass('has-error').find('.erro_msg')
                                .text('')
                            return
                        }
                        if (!cache.form) {
                            console.log('must run build ')
                            return
                        }
                        cache.form.find('.form-group, .input-group').each(function (idx) {
                            $(this).removeClass('has-error')
                            $(this).find('.erro_msg').text('')
                        })
                    },
                }
            }())
            // setInterval(() => {
            //     console.dir(scope.ele.serializeArray())
            // }, 5000);
            scope.$watch('ele.serializeArray()', () => {
                init()
            }, true)

            function init() {
                // 组件实例化时重置 验证集合类 这个是个单例可能会有点问题
                validator.reset()
                const el = element[0]
                for (let i = 0; i < el.length; i++) {
                    //                     angular.forEach(element[0],function (data,idx) {
                    if (!el[i].name) continue
                    const a = el[i].name
                    let rule = null
                    if (validateRules) {
                        if (validateRules.hasOwnProperty(a)) {
                            rule = validateRules[a]
                        }
                    }
                    validator.set($form[a], rule, formPO.build(element, el[i]).rejected)
                }
                //                    for (var a in validateRules ) {
                //                        var rule = validateRules[a];
                //                        Validator.set( $form[a],rule,formPO.build(element,$form[a]).rejected); // validatorprint
                //                    }
                formvalidateApi.clear = formPO.clear
                formvalidateApi.run = function (formName, noScroll) {
                    formvalidateApi.clear()
                    const result = validator.run(formName)
                    if (!result && !noScroll) {
                        setTimeout(() => {
                            const firstError = element.find('.has-error')[0]
                            firstError && firstError.scrollIntoView()
                            window.scrollTo(window.scrollX, window.scrollY - 65)
                        }, 300)
                    }
                    return result
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/formvalidate/formvalidate.js